import { getInventoryDriverSuggestions } from '@/api/generated/inventory-vehicles/inventory-vehicles';
import type { DriverSuggestion, ListRequest } from '@/api/generated/schemas';
import { createAsyncSelectorField } from '@/shared/forms';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';

/**
 * UI ref preferovaného řidiče — identitou je `WorkPersonFacility.FacilityID` (pracovní role),
 * ne osoba. Backend nabízí jen aktivní nesmazané role s rolí `WorkRole.Driver`.
 */
export interface DriverRef {
  workPersonFacilityId: number;
  name: string;
}

const driverSelector = defineEntityAsyncSelector<
  DriverRef,
  DriverSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getInventoryDriverSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('inventory.drivers', request),
    mapItem: (dto) => ({ workPersonFacilityId: dto.workPersonFacilityId, name: dto.name }),
  },
  key: (item) => item.workPersonFacilityId,
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
  },
  columns: (t) => [
    {
      id: 'name',
      header: t('driverSelector.cols.name'),
      sortable: true,
      cell: (item: DriverRef) => item.name,
      flex: '1',
    },
  ],
  i18n: { namespace: 'inventory' },
});

export const DriverSelector = driverSelector.Selector;
export const DriverSelectorField = createAsyncSelectorField(DriverSelector);
